import { ZepColorPrimaryIcon, ZepQuizColorPrimaryIcon, ZepSchoolColorPrimaryIcon } from '@zep-us/zus-icons';
export const ServiceMenuIcon = ({
  name
}: {
  name: string;
}) => {
  switch (name) {
    case 'ZEP':
      return <ZepColorPrimaryIcon />;
    case 'ZEP QUIZ':
      return <ZepQuizColorPrimaryIcon />;
    case 'ZEP SCHOOL':
      return <ZepSchoolColorPrimaryIcon />;
    case 'ZEP BOARD':
      // Same branch marker as QUIZ: BOARD is a product within ZEP QUIZ.
      return <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M7.2 7.2V13.8C7.2 15.4569 8.54315 16.8 10.2 16.8H16.8" className="text-gray-400" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>;
  }
};